export const nullValuesToUndefined = <T>(data: NonNullable<T>): Partial<T> => {
  return Object.entries(data).reduce(
    (accumulator: Partial<T>, [key, value]) => {
      accumulator[key as keyof T] = value === null ? undefined : value;
      return accumulator;
    },
    {}
  );
};
